var menu = require('./menu');
var mute = require('./mute');
var menuLevels = require('./menuLevels');

jQuery(function($) {
	
	menu.setHandlers();
	mute.setHandlers();
	
});